<script setup lang="ts">
import { t } from '@/i18n';
import { ref, watch, nextTick, onBeforeUnmount, useId, toRef } from 'vue';
import { X } from '@lucide/vue';
import { useScrollLock } from '@/composables/useScrollLock';
const props=withDefaults(defineProps<{open:boolean;title:string;size?:'md'|'lg'}>(),{size:'md'});
const emit=defineEmits<{close:[]}>();const dialog=ref<HTMLDialogElement>();const titleId=useId();
const pressedBackdrop=ref(false);
useScrollLock(toRef(props, 'open'));
watch(()=>props.open,async open=>{
  await nextTick();
  if (open !== props.open) return;
  if(open) dialog.value?.showModal();
  else dialog.value?.close();
},{immediate:true});
onBeforeUnmount(()=>dialog.value?.close());
</script>
<template><Teleport to="body"><dialog ref="dialog" class="modal-dialog" :class="size" :aria-labelledby="titleId" @cancel.prevent="emit('close')" @pointerdown="e=>{pressedBackdrop=e.target===dialog}" @click="e=>{if(pressedBackdrop && e.target===dialog)emit('close')}"><div class="modal-inner"><header class="modal-header"><h2 :id="titleId">{{title}}</h2><button type="button" class="icon-btn" :aria-label="t('common.closeDialog')" @click="emit('close')"><X aria-hidden="true"/></button></header><div class="modal-body"><slot/></div><footer v-if="$slots.footer" class="modal-footer"><slot name="footer"/></footer></div></dialog></Teleport></template>
